import { gql } from '@apollo/client';

export const getClauseEnums = gql`
  query getClauseEnums {
    PlanConfigManagement_ClauseStatuses: __type(
      name: "PlanConfigManagement_ClauseStatuses"
    ) {
      name
      enumValues {
        name
      }
    }
    PlanConfigManagement {
      queries {
        allLines {
          planConfigManagement_Line_Id
          planConfigManagement_Line_Name
        }
      }
    }
  }
`;

export const checkClauseExists = gql`
  query checkClauseExists(
    $lineId: String
    $name: String
    $externalCode: String
    $clauseId: String
  ) {
    PlanConfigManagement {
      queries {
        checkClauseExists(
          lineId: $lineId
          clauseId: $clauseId
          name: $name
          externalCode: $externalCode
        ) {
          planConfigManagement_Clause_Id
        }
      }
    }
  }
`;

export const getClauseInfo = gql`
  query getClauseInfo($id: String!) {
    PlanConfigManagement {
      entities {
        clause(id: $id) {
          views {
            PlanConfigManagement_all {
              properties {
                ExternalCode
                Name
                Description
                Status
              }
            }
          }
        }
      }
    }
  }
`;

export const createClause = gql`
  mutation createClause($clauseInputs: PlanConfigManagement_ClauseInputs!) {
    planConfigManagement {
      actions {
        createClause(clauseInputs: $clauseInputs) {
          id
        }
      }
    }
  }
`;

export const updateClause = gql`
  mutation updateClause(
    $entityId: String!
    $clauseInputs: PlanConfigManagement_ClauseInputs!
  ) {
    planConfigManagement {
      entities {
        clause {
          planConfigManagement {
            updateClause(entityId: $entityId, clauseInputs: $clauseInputs) {
              id
            }
          }
        }
      }
    }
  }
`;
